import { c as _c } from "react/compiler-runtime";
// «Возвраты» — макет «Профиль»: сегменты «Активные | Открыт спор | Архив»,
// сегменты поровну 3 × 132 (кадр 3945:43228); карточки заявок через 12 (белые
// r20, p12/16/20/16: статус 16/20 w600 слева, «Заявка от 14 мая» 14/18 #000 50 %
// справа, миниатюры 50×66 r4 с количеством). GET /buyer/returns?tab=…

import { Skeleton } from "@osmix/ui/skeleton";
import { useQuery } from "@tanstack/react-query";
import { Link, useSearchParams } from "react-router";
import { api, type BuyerReturnTab } from "@/api";
import { ProfilePanel, ProfileSegments } from "@/components/profile/profile-shell";
import { CabinetEmpty, fmtDayMonth, Thumb } from "@/components/profile/return-parts";
import { RETURN_TAB_LABEL, returnStatusLabel } from "@/components/profile/return-status";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useProfile } from "@/store";
const TABS: BuyerReturnTab[] = ["active", "dispute", "archive"];
export function ProfileReturnsPage() {
  const $ = _c(23);
  const userId = useProfile(_temp);
  const [params, setParams] = useSearchParams();
  let t0;
  if ($[0] !== params) {
    t0 = params.get("tab");
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const raw = t0;
  const tab = raw === "dispute" || raw === "archive" ? raw : "active";
  let t1;
  if ($[2] !== tab || $[3] !== userId) {
    t1 = ["buyer", userId, "returns", tab];
    $[2] = tab;
    $[3] = userId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== tab) {
    t2 = () => api.cabinet.returns(tab);
    $[5] = tab;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const list = useQuery(t3);
  let t4;
  if ($[10] !== setParams) {
    t4 = v => setParams(v === "active" ? {} : {
      tab: v
    }, {
      replace: true
    });
    $[10] = setParams;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = TABS.map(_temp2);
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== tab) {
    t6 = <ProfileSegments value={tab} onChange={t4} options={t5} equal={true} className="md:w-[408px]" />;
    $[13] = t4;
    $[14] = tab;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== list.data || $[17] !== list.isPending || $[18] !== tab) {
    t7 = list.isPending ? <div className="flex flex-col gap-2.5">{[0, 1].map(_temp3)}</div> : (list.data ?? []).length === 0 ? <CabinetEmpty title={tab === "active" ? "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0437\u0430\u044F\u0432\u043E\u043A \u043D\u0435\u0442" : tab === "dispute" ? "\u0421\u043F\u043E\u0440\u043E\u0432 \u043D\u0435\u0442" : "\u0410\u0440\u0445\u0438\u0432 \u043F\u0443\u0441\u0442"} hint={tab === "active" ? "\u0412\u0435\u0440\u043D\u0443\u0442\u044C \u0442\u043E\u0432\u0430\u0440 \u043C\u043E\u0436\u043D\u043E \u0438\u0437 \xAB\u041C\u043E\u0438 \u0437\u0430\u043A\u0430\u0437\u044B\xBB \u2192 \xAB\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0435\xBB." : undefined} action={tab === "active" ? <Button variant="gray" size="sm" asChild={true}><Link to="/profile/orders">Перейти к заказам</Link></Button> : undefined} /> : <div className="flex flex-col gap-3">{(list.data ?? []).map(r => {
        const st = returnStatusLabel(r);
        const lines = r.lines.filter(_temp4);
        const shown = lines.length ? lines : r.lines;
        return <Link key={r.id} to={`/profile/returns/${encodeURIComponent(r.id)}?tab=${tab}`} className="flex flex-col gap-3 rounded-[20px] bg-white px-4 pt-3 pb-5 outline-none transition-shadow hover:shadow-[0_2px_12px_rgba(0,0,0,0.05)] focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40"><div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5"><span className={cn("whitespace-nowrap text-[16px] leading-5 font-semibold tracking-[-0.31px]", st.className)}>{st.label}</span><span className="shrink-0 text-[14px] leading-[18px] text-black/50">Заявка от {fmtDayMonth(r.createdAt)}</span></div><div className="flex gap-1 overflow-hidden">{shown.map(_temp5)}</div></Link>;
      })}</div>;
    $[16] = list.data;
    $[17] = list.isPending;
    $[18] = tab;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <ProfilePanel title={"\u0412\u043E\u0437\u0432\u0440\u0430\u0442\u044B"}>{t6}{t7}</ProfilePanel>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
function _temp5(l_0) {
  return <Thumb key={l_0.id} src={l_0.photo} label={l_0.quantity > 1 ? `${l_0.quantity} шт.` : undefined} />;
}
function _temp4(l) {
  return !l.cancelledAt;
}
function _temp3(i) {
  return <Skeleton key={i} className="h-24 rounded-[20px]" />;
}
function _temp2(value) {
  return {
    value,
    label: RETURN_TAB_LABEL[value]
  };
}
function _temp(s) {
  return s.user?.id ?? "guest";
}